import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-cvv-modal',
  templateUrl: './cvv-modal.component.html',
  styleUrls: ['./cvv-modal.component.scss'],
  standalone: false
})
export class CvvModalComponent implements OnInit {
  appStrings: AppLocalization;
  cvvVisaImgPath = '../../../../../../assets/resources/payment/cvvvisa.jpg';
  cvvAmexImgPath = '../../../../../../assets/resources/payment/cvvamex.jpg';

  constructor(
    private dialogRef: MatDialogRef<CvvModalComponent>,
    private appInfoService: AppInfoService,
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    if (this.appInfoService.state.isElectron) {
      this.cvvVisaImgPath = '/Program%20Files/Snapon%20IMPACT/snapon-impact-win32-x64/resources/app/assets/resources/payment/cvvvisa.jpg';
      this.cvvAmexImgPath = '/Program%20Files/Snapon%20IMPACT/snapon-impact-win32-x64/resources/app/assets/resources/payment/cvvamex.jpg';
    }
  }

  close() {
    this.dialogRef.close();
  }

}
